module.exports = __webpack_public_path__ + "img/title-shiba.7175dac5.png";